import React from "react";

function ArrowDownShort() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      fill="none"
      viewBox="0 0 33 33"
    >
      <path
        fill="#CED4DA"
        fillRule="evenodd"
        d="M9.582 15.77a1.032 1.032 0 011.46 0l5.458 5.46 5.457-5.46a1.032 1.032 0 111.46 1.46l-6.187 6.188a1.03 1.03 0 01-1.46 0L9.582 17.23a1.032 1.032 0 010-1.46z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#CED4DA"
        fillRule="evenodd"
        d="M16.5 9.281a1.031 1.031 0 011.031 1.031v10.313a1.031 1.031 0 11-2.062 0V10.312a1.031 1.031 0 011.031-1.03z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default ArrowDownShort;
